import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const OurAchievementsThunk = createAsyncThunk(
	"OurAchievementsThunk",
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				"https://api.msr7unaizah-com-606441.hostingersite.com/api/public/achievements"
			);

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
